import React from 'react';
import {
  CssBaseline,
  Button,
  Grid,
  Radio,
  Table,
  TableBody,
  TableRow,
  TableCell,
  // Typography,
  TextField,
  withStyles,
} from '@material-ui/core';

import axiosInstance, {
  // addComma,
  // checkDeadline,
  // EVENT_CODE,
  // getEventId,
  setScrollPosition,
  EVENT_ID,
  getUserID,
  WEB_API,
  // REGISTRAIONSUBMIT_TEMPLATE,
  F_EMAIL,
  BCC_ADDR_EMAIL_REG,
} from '../constatns';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import swal from '@sweetalert/with-react';
import Calendar from 'react-calendar';
import SubTitle from '../components/Text/SubTitle';
import moment from 'moment';

// import RegistrationSubmissionForm from './RegistrationSubmissionForm';
// import ConfirmButton from '../components/Button/ConfirmButton';

import { FreeDinnerLicense } from './FreeDinnerLicense';

const styles = (theme) => ({
  infoText: {
    color: '#e91e5c',
    fontSize: '1.1em',
    marginTop: theme.spacing(1),
    '& p': {
      textIndent: '-1.1em',
      paddingLeft: '1em',
    },
    '& p:not(:last-child)': {
      marginBottom: theme.spacing(0.5),
    },
  },

  //table
  tableBody1: {
    '& th': {
      width: '15%',
      textAlign: 'center',
      wordBreak: 'keep-all',
    },
    '& td:first-child': {
      width: '85%',
    },
    // '& td:nth-child(n+2)': {
    //   width: '18.333%',
    // },
  },
  tableHeadAlignCenter: {
    '& th': {
      textAlign: 'center',
    },
  },
  tableBodyAlignCenter: {
    '& td': {
      textAlign: 'center',
    },
  },

  tableBorder: {
    '& th:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
    '& td:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },

  cancelInfoDiv: {
    padding: theme.spacing(4, 5),
    border: '2px solid rgb(205, 205, 205)',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
});

const StyledTableCell = withStyles((theme) => ({
  root: {
    fontSize: '1.3em',
  },
}))(TableCell);

const CustomTableCell = withStyles((theme) => ({
  root: {
    fontSize: '1.3em',
    padding: '0 auto',
    fontWeight: 'bold',
  },
}))(TableCell);

const CustomTableCell2 = withStyles((theme) => ({
  root: {
    border: '1px solid #fff',
    backgroundColor: '#e9eef1',
    color: '#000000',
    fontSize: '1.3em',
    // fontWeight: 'bold',
    textAlign: 'left',
  },
}))(TableCell);

class GalaDinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: '',
      // 결제방법 - 은행 송금
      remitterName: '', //송금자명
      remittanceDate: '', //송금일
      isShowCalendar: false, //송금일 달력 on/off
      companion: '',
      companionName: '',
      status: '',
      isFree: '',
    };
  }

  componentDidMount() {
    // window.addEventListener('message', this.receiveMessage);
    if (moment().tz('Asia/Seoul').isAfter('2023-12-31 23:59:59')) {
      swal('', 'Gala Dinner registration period has ended', 'info');
      this.movePage('/');
      return;
    } else {
      setScrollPosition(0);
      if (!sessionStorage.getItem('_in_user_')) {
        this.movePage('/signin');
      } else {
        axiosInstance.get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`).then((res) => {
          if (res.data.Item && res.data.Item.license) {
            // console.log(res.data.Item.license, 'license');
            const Lincense = res.data.Item.license;
            this.checkLicense(Lincense);
            if (this.state.isFree === true) {
              swal({
                title: '무료등록자',
                text: '갈라디너 신청 관련 문의는 대한성형외과학회 (02-3472-4252)로 문의하여 주시기 바랍니다.',
                type: 'warning',
                showCancelButton: false,
                closeOnConfirm: false,
                confirmButtonColor: '#237a9d',
              }).then((value) => {
                this.movePage('/main');
              });
            }
          }
          if (res.data.Item && res.data.Item.dinnerStatus && res.data.Item.dinnerStatus !== '') {
            swal('', 'Gala dinner registration is already completed.', 'error').then((value) => {
              this.movePage('/');
            });
          }
          if (res.data.Item && res.data.Item.status !== 'Complete') {
            swal('', 'Pre-registration is required.', 'error').then((value) => {
              this.movePage('/registration/guide');
            });
          }
        });

        this.setState(
          {
            language: sessionStorage.getItem('_in_country') === 'Korea, Republic of' ? 'korean' : 'english',
          },
          () => {},
        );
      }
    }
  }

  componentWillUnmount() {}

  checkLicense(Lincense) {
    if (FreeDinnerLicense.indexOf(Lincense) !== -1) {
      this.setState({ isFree: true });
    }
  }

  handleState(e, key) {
    this.setState({ [key]: e.target.value });
  }

  handleDate = (val) => {
    this.setState({ remittanceDate: val, isShowCalendar: false });
  };

  movePage = (url) => {
    if (url) this.props.history.push(url);
    else this.props.history.goBack();
  };

  spacing = (height) => {
    return (
      <Grid item xs={8}>
        <div style={height ? { height: `${height}px` } : { height: '20px' }} />
      </Grid>
    );
  };

  init() {}

  onSubmit() {
    let Param = {
      evt: EVENT_ID,
      userId: getUserID(true),
      dinnerStatus: 'waiting',
      dinnerComp: this.state.companion,
      compName: this.state.companion === 'O' ? this.state.companionName : '',
      dinnerDepositor: this.state.remitterName,
      dinnerDate: this.state.remittanceDate,
    };
    axiosInstance.put(`${WEB_API}/user/dinner`, Param).then((res) => {
      if (res.status === 200) {
        // 등록완료메일
        axiosInstance
          .post(
            `${WEB_API}/user/dinnerEmail?evt=${EVENT_ID}&userId=${
              Param.userId
            }&templateName=${'DinnerWaitPRS2022'}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`,
          )
          .then((response) => {
            swal('', 'Gala Dinner Registration is completed', 'success');
            this.movePage('/');
          });
      }
    });
  }

  renderDinner() {
    const { classes } = this.props;

    return (
      <Table>
        <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter} ${classes.tableBodyAlignCenter}`}>
          <TableRow id={'dinner'} style={{ borderTop: '2px solid #237a9d' }}>
            <StyledTableCell width={'50%'}>
              <Radio
                color="primary"
                checked={this.state.companion === 'O'}
                onChange={(e) => {
                  this.setState({ companion: 'O' });
                }}
                value={'O'}
              />
              O
            </StyledTableCell>
            <StyledTableCell width={'50%'}>
              <Radio
                color="primary"
                checked={this.state.companion === 'X'}
                onChange={(e) => {
                  this.setState({ companion: 'X', companionName: '' });
                }}
                value={'X'}
              />
              X
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderBankTransfer() {
    const { classes } = this.props;
    const { language } = this.state;

    return (
      <>
        {/* {this.spacing(10)} */}
        <Grid item xs={this.props.isAdmin ? 11 : 8}>
          <Table>
            <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter}`}>
              <TableRow style={{ borderTop: '2px solid #237a9d' }}>
                <StyledTableCell component={'th'} width={'35%'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                  {language === 'korean' ? '은행명' : 'Bank Name'}
                </StyledTableCell>
                <StyledTableCell width={'65%'}>{language === 'korean' ? '하나은행' : 'Hana Bank'}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell component={'th'} width={'35%'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                  {language === 'korean' ? '계좌명' : 'Beneficiary Account'}
                </StyledTableCell>
                <StyledTableCell width={'65%'}>
                  {language === 'korean' ? '대한성형외과학회' : 'Korean Society of Plastic and Reconstructive Surgeons (KSPRS)'}
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell component={'th'} width={'35%'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                  {language === 'korean' ? '계좌번호' : 'Account Number'}
                </StyledTableCell>
                <StyledTableCell width={'65%'}>{language === 'korean' ? '261-910022-59704' : '224-910007-31232'}</StyledTableCell>
              </TableRow>
              {language !== 'korean' && (
                <>
                  <TableRow>
                    <StyledTableCell component={'th'} width={'35%'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                      Swift Code
                    </StyledTableCell>
                    <StyledTableCell width={'65%'}>KOEXKRSE or KOEXKRSEXXX</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component={'th'} width={'35%'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                      Branch Name
                    </StyledTableCell>
                    <StyledTableCell width={'65%'}>Seochonam Banking Center</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component={'th'} width={'35%'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                      Bank Address
                    </StyledTableCell>
                    <StyledTableCell width={'65%'}>06733, Seoun-ro 3, Seocho-gu, Seoul</StyledTableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <StyledTableCell component={'th'} width={'35%'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                  {language === 'korean' ? '송금자명' : `Registrant's name`}
                </StyledTableCell>
                <StyledTableCell width={'65%'}>
                  <TextField
                    variant={'outlined'}
                    type={'text'}
                    size={'small'}
                    value={this.state.remitterName}
                    onChange={(e) => this.handleState(e, 'remitterName')}
                    inputRef={this.refRemitterName}
                    style={{ width: '50%' }}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell component={'th'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                  {language === 'korean' ? '송금예정일' : 'Remittance Due Date'}
                </StyledTableCell>
                <StyledTableCell width={'65%'}>
                  <TextField
                    InputProps={{
                      readOnly: true,
                    }}
                    variant={'outlined'}
                    type={'text'}
                    size={'small'}
                    value={this.state.remittanceDate === '' ? '' : moment(this.state.remittanceDate).format('YYYY-MM-DD')}
                    onClick={() => {
                      this.setState((prevState) => ({ isShowCalendar: !prevState.isShowCalendar }));
                    }}
                    inputRef={this.refRemittanceDate}
                    style={{ width: '50%' }}
                  />
                  {this.state.isShowCalendar && (
                    <div>
                      <Calendar locale={language === 'korean' ? 'ko' : 'en'} onChange={this.handleDate} />
                    </div>
                  )}
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </>
    );
  }

  render() {
    const { language } = this.state;
    // console.log('isFree:', this.state.isFree);

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={3} SIdx={3} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Gala Dinner</MainTitle>
            </Grid>
            <Grid item xs={this.props.isAdmin ? 11 : 8}>
              <SubTitle>Guideline</SubTitle>
              <Table>
                <TableBody>
                  <TableRow>
                    <CustomTableCell
                      align="center"
                      width={'30%'}
                      component={'th'}
                      style={{ backgroundColor: '#237a9d', color: '#fff', height: 90 }}
                    >
                      Deadline for Gala Dinner Registration
                    </CustomTableCell>
                    <CustomTableCell2 align="center">October 28(Fri), 2022</CustomTableCell2>
                  </TableRow>
                  <TableRow>
                    <CustomTableCell
                      align="center"
                      component={'th'}
                      width={'20%'}
                      style={{ backgroundColor: '#237a9d', color: '#fff', height: 90 }}
                    >
                      Venue
                    </CustomTableCell>
                    <CustomTableCell2 align="center">Grand InterContinental Seoul Parnas, Grand Ballroom 1+2+3 (5F)</CustomTableCell2>
                  </TableRow>
                  <TableRow>
                    <CustomTableCell
                      align="center"
                      component={'th'}
                      width={'20%'}
                      style={{ backgroundColor: '#237a9d', color: '#fff', height: 90 }}
                    >
                      Date
                    </CustomTableCell>
                    <CustomTableCell2 align="center">November 12(Sat), 18:30~</CustomTableCell2>
                  </TableRow>
                  <TableRow>
                    <CustomTableCell
                      align="center"
                      component={'th'}
                      width={'20%'}
                      style={{ backgroundColor: '#237a9d', color: '#fff', height: 90 }}
                    >
                      Gala Dinner Fee
                    </CustomTableCell>
                    <CustomTableCell2 align="center">
                      KRW 30,000 / For Korean
                      <br />
                      USD 30 / For International
                    </CustomTableCell2>
                  </TableRow>
                </TableBody>
              </Table>

              <ul style={{ fontWeight: 500, fontSize: '1.2em', lineHeight: 1.8, color: '#000000' }}>
                <li>
                  {language === 'korean'
                    ? 'Gala Dinner 신청은 학술대회에 등록해주신 회원에 한하여 신청이 가능하며 준비된 좌석이 한정되어 있어 조기 마감될 수 있습니다.'
                    : 'Gala Dinner can be registered pre-registrants only and it will be closed early due to prepared seat is limited.)'}
                </li>
                <li>
                  {language === 'korean'
                    ? 'Gala Dinner 신청을 원하시는 경우 사전등록 후 아래 정보 입력하여 주시기 바랍니다.'
                    : 'If you would like to register for Gala Dinner, please fill out the information below.'}
                </li>
              </ul>
            </Grid>
            {this.spacing(30)}

            <Grid item xs={this.props.isAdmin ? 11 : 8}>
              <SubTitle>
                {language === 'korean'
                  ? '동반인 유무 (동반 1인 추가 등록 가능)'
                  : 'Attendance of Accompanying Person (One additional person can be registered)'}
              </SubTitle>
              {this.renderDinner()}
            </Grid>
            {this.spacing(30)}

            {this.state.companion && this.state.companion === 'O' && (
              <Grid item xs={this.props.isAdmin ? 11 : 8}>
                <SubTitle>{language === 'korean' ? '동반자 정보' : 'Information for Accompanying Person'}</SubTitle>
                <Table>
                  <TableBody>
                    <TableRow style={{ borderTop: '2px solid #237a9d' }}>
                      <StyledTableCell component={'th'} width={'35%'} style={{ backgroundColor: '#f8f8f8', fontWeight: 'bold' }}>
                        {language === 'korean' ? 'NAME(ENG)' : `NAME(ENG)`}
                        {language === 'korean' ? (
                          <span style={{ color: '#f00' }}>
                            <br />* 동반자 성함은 영문으로 기입 부탁드립니다.{' '}
                          </span>
                        ) : (
                          ''
                        )}
                      </StyledTableCell>
                      <StyledTableCell width={'65%'} align="center">
                        <TextField
                          variant={'outlined'}
                          type={'text'}
                          size={'small'}
                          value={this.state.companionName}
                          onChange={(e) => this.handleState(e, 'companionName')}
                          inputRef={this.companionName}
                          style={{ width: '80%' }}
                        />
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
            )}
            {this.spacing(30)}

            <Grid item xs={this.props.isAdmin ? 11 : 8}>
              <SubTitle>{language === 'korean' ? '결제방법 -계좌이체' : 'Payment Method-Bank Transfer'}</SubTitle>
            </Grid>
            <Grid container justifyContent="center">
              {this.renderBankTransfer()}
            </Grid>
            {this.spacing(30)}
          </Grid>

          <Grid container justifyContent="center">
            <Grid container justifyContent="center" item xs={this.props.isAdmin ? 11 : 8}>
              <Button
                color="primary"
                variant="contained"
                style={{ fontSize: 22, padding: '20px 40px', textTransform: 'none', marginRight: 20 }}
                onClick={() => {
                  this.setState({
                    remitterName: '', //송금자명
                    remittanceDate: '', //송금일
                    companion: '', //동반인 유무
                    companionName: '', //동반인 성함
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                variant="contained"
                style={{ fontSize: 22, padding: '20px 40px', textTransform: 'none', marginLeft: 20 }}
                onClick={() => {
                  this.onSubmit();
                }}
                disabled={
                  this.state.companion === '' ||
                  (this.state.companion === 'O' && this.state.companionName === '') ||
                  this.state.remitterName === '' ||
                  this.state.remittanceDate === ''
                }
              >
                Submit
              </Button>
            </Grid>
          </Grid>
          {this.spacing(130)}
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(GalaDinner);
